"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
var ArrowKeys;
(function (ArrowKeys) {
    ArrowKeys["left"] = "ArrowLeft";
    ArrowKeys["up"] = "ArrowUp";
    ArrowKeys["right"] = "ArrowRight";
    ArrowKeys["down"] = "ArrowDown";
})(ArrowKeys || (ArrowKeys = {}));
const useKeyboardDrag = () => {
    const [pos, setPos] = react_1.useState({ x: 0, y: 0 });
    const [enabled, setEnabled] = react_1.useState(false);
    const handleKeydown = react_1.useCallback((e) => {
        if (!enabled)
            setEnabled(true);
        switch (e.key) {
            case ArrowKeys.left:
                if (pos.x > -400) {
                    setPos(Object.assign(Object.assign({}, pos), { x: pos.x -= 5 }));
                }
                break;
            case ArrowKeys.right:
                if (pos.x < 400) {
                    setPos(Object.assign(Object.assign({}, pos), { x: pos.x += 5 }));
                }
                break;
            case ArrowKeys.up:
                if (pos.y > -400) {
                    setPos(Object.assign(Object.assign({}, pos), { y: pos.y -= 5 }));
                }
                break;
            case ArrowKeys.down:
                if (pos.y < 400) {
                    setPos(Object.assign(Object.assign({}, pos), { y: pos.y += 5 }));
                }
                break;
            default:
                setEnabled(false);
        }
    }, [setPos, setEnabled]);
    react_1.useEffect(() => {
        document.addEventListener('keydown', handleKeydown);
        document.removeEventListener('click', () => setEnabled(false));
        return () => {
            document.removeEventListener('keydown', handleKeydown);
            setEnabled(false);
        };
    }, []);
    return [{ enabled, x: pos.x, y: pos.y }, setEnabled];
};
exports.default = useKeyboardDrag;
